import {
  default as authSelector,
  default as corporateSelector,
} from 'modules/Auth/selectors'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { readDownloadErrorMessage } from 'utils/downloadFile'
import corporateRequest from 'utils/corporateRequest'
import instituteRequest from 'utils/instituteRequest'
import request from 'utils/request'
import studentRequest from 'utils/studentRequest'

export const SET_DRIVE_METRICS = 'corporate/SET_DRIVE_METRICS'
export const SET_DRIVE_ROLES_METRICS = 'corporate/SET_DRIVE_ROLES_METRICS'
export const SET_ROLE_METRICS = 'corporate/SET_ROLE_METRICS'
export const SET_DRIVE_DATA = 'corporate/SET_DRIVE_DATA'
export const SET_INTERVIEWR_LIST = 'corporate/SET_INTERVIEWR_LIST'
export const SET_DRIVE_INTERVIEWR_LIST = 'corporate/SET_DRIVE_INTERVIEWR_LIST'
export const SET_DEGREE_LIST = 'corporate/SET_DEGREE_LIST'
export const SET_COLLEGE_LIST = 'corporate/SET_COLLEGE_LIST'
export const SET_CANDIDATE_INTERVIEW_DETAILS =
  'corporate/SET_CANDIDATE_INTERVIEW_DETAILS'
export const SET_GROUP_LIST = 'corporate/SET_GROUP_LIST'
export const SET_GROUP_CANDIDATE__LIST = 'corporate/SET_GROUP_CANDIDATE__LIST'
export const SET_CITY_LIST = 'corporate/SET_CITY_LIST'
export const SET_RECREATE = 'corporate/SET_RECREATE'
export const SET_CANDIDATE_DOCUMENTS_METRICES =
  'coporate/SET_CANDIDATE_DOCUMENTS_METRICES'
export const SET_NEW_DRIVE_FRESHERS_LIST = `SET_NEW_DRIVE_FRESHERS_LIST`
export const SET_NEW_STATUS = 'corporate/SET_NEW_STATUS'
export const SET_NEW_SCORE = 'corporate/SET_NEW_SCORE'
export const SET_NEW_DRIVE_METRICS = `corporate/SET_NEW_DRIVE_METRICS`
export const SET_PANEL_DATA = `corporate/SET_PANEL_DATA`
export const SET_RESUME = `resume_bulk_download`
export const SET_ROUND_DATA = 'institute/SET_ROUND_DATA'
export const UPDATE_ROUND_DATA = 'institute/UPDATE_ROUND_DATA'
export const SET_STATUS_LIST = 'corporate/SET_STATUS_LIST'
export const setPanelData = data => {
  return {
    type: SET_PANEL_DATA,
    data,
  }
}
export const setNewDriveFreshersList = data => {
  return {
    type: SET_NEW_DRIVE_FRESHERS_LIST,
    data,
  }
}
export const setNewDriveStatus = data => {
  return {
    type: SET_NEW_STATUS,
    data,
  }
}
export const setNewDriveScore = data => {
  return {
    type: SET_NEW_SCORE,
    data,
  }
}
export const setNewDriveStatusUpdation = data => {
  return {
    type: SET_NEW_DRIVE_METRICS,
    data,
  }
}
export const setDriveMetrics = data => {
  return {
    type: SET_DRIVE_METRICS,
    data,
  }
}
export const setDriveRolesMetrics = data => {
  return {
    type: SET_DRIVE_ROLES_METRICS,
    data,
  }
}

export const setRoleMetrics = data => {
  return {
    type: SET_ROLE_METRICS,
    data,
  }
}

export const setDrivesData = data => {
  return {
    type: SET_DRIVE_DATA,
    data,
  }
}

export const setInterviewerList = data => {
  return {
    type: SET_INTERVIEWR_LIST,
    data,
  }
}

export const setDriveInterviewerList = data => {
  return {
    type: SET_DRIVE_INTERVIEWR_LIST,
    data,
  }
}

export const setDegreeList = data => {
  return {
    type: SET_DEGREE_LIST,
    data,
  }
}

export const setCollegeList = data => {
  return {
    type: SET_COLLEGE_LIST,
    data,
  }
}

export const setCandidateInterviewDetails = data => {
  return {
    type: SET_CANDIDATE_INTERVIEW_DETAILS,
    data,
  }
}

export const setGroupList = data => {
  return {
    type: SET_GROUP_LIST,
    data,
  }
}

export const setGroupCandidateList = data => {
  return {
    type: SET_GROUP_CANDIDATE__LIST,
    data,
  }
}

export const setCityList = data => {
  return {
    type: SET_CITY_LIST,
    data,
  }
}
export const setRecreate = data => {
  return {
    type: SET_RECREATE,
    data,
  }
}

export const setCandidateDocumentsMetrices = data => {
  return {
    type: SET_CANDIDATE_DOCUMENTS_METRICES,
    data,
  }
}
export const setResumeData = data => {
  return {
    type: SET_RESUME,
    data,
  }
}
export const updateRoundData = data => {
  return {
    type: UPDATE_ROUND_DATA,
    data,
  }
}
export const setRoundData = data => {
  return {
    type: SET_ROUND_DATA,
    data,
  }
}
export const setStatusList = data => {
  return {
    type: SET_STATUS_LIST,
    data,
  }
}
export const getPanelList =
  ({ driveId, roleId, roundName, panelId }) =>
  async () => {
    try {
      const response = corporateRequest.get(
        `/corporates/role/${roleId}/drive/${driveId}/interviewRound/panel/${panelId}?interviewRound=${roundName}`
      )
      return response
    } catch (error) {
      return error
    }
  }

export const getNewIndividualDriveStatus =
  (driveId, roleId, payLoad, getCandidateList, getRoleMetrics) =>
  async (dispatch, getState) => {
    try {
      const response = await corporateRequest.put(
        `/corporates/jobs/${roleId}/evaluation/status/update`,
        payLoad
      )
      dispatch(setNewDriveStatusUpdation(response?.data?.message))

      if (response?.status >= 200 && response?.status <= 300) {
        SuccessMessage('Updated Successfully')
        if (getCandidateList) {
          getCandidateList()
        }
        if (getRoleMetrics) {
          getRoleMetrics()
        }
      }

      return response
    } catch (error) {
      ErrorMessage('Failed to update')
      return error
    }
  }

export const getNewDriveScore = (driveId, roleId, stage) => async dispatch => {
  dispatch(setNewDriveScore([]))

  const stageFilter =
    stage && stage !== 'all_candidates' ? `?stage=${stage}` : ''
  try {
    const response = await corporateRequest.get(
      `/corporates/drive/${driveId}/role/${roleId}/score/list${stageFilter}`
    )
    dispatch(setNewDriveScore(response?.data?.data || {}))
    return response
  } catch (error) {
    return error
  }
}
export const getNewDriveStatus = (driveId, roleId, stage) => async dispatch => {
  const stageFilter =
    stage && stage !== 'all_candidates' ? `?stage=${stage}` : ''

  try {
    const response = await corporateRequest.get(
      `/corporates/drive/${driveId}/role/${roleId}/status/list${stageFilter}`
    )
    dispatch(setNewDriveStatus(response?.data?.data || {}))

    return response
  } catch (error) {
    return error
  }
}
export const getNewDriveFreshersList =
  ({
    driveId,
    roleId,
    currentPage = 0,
    searchValue,
    sortBy,
    status,
    stage,
    candidateRating,
    checkedIds,
    college,
    rolesMetrics,
    scorePayload,
    panelValue,
    isActive = false,
    bulkDownload,
    filterPayload,
  }) =>
  async () => {
    try {
      const search = searchValue ? `&search=${encodeURIComponent(searchValue.trim())}` : '';
      const panel = panelValue && panelValue !== 'all' ? `&panelId=${panelValue}` : '';
      const order = sortBy?.order === 'ascend'
        ? 'asc'
        : sortBy?.order === 'descend'
        ? 'desc'
        : '';

      const candidateStatus =
        stage === 'all_candidates' && (status === 'APPLIED_TAB' || status === 'INVITED_TAB')
          ? ''
          : status && status !== 'ACTIVE' && stage !== 'offer'
          ? `&status=${status}`
          : stage === 'offer'
          ? `&status=SELECTED`
          : '';

      const activeStatus = isActive ? `&isActive=${isActive}` : '';
      const stageValue =
        stage === null
          ? `&stage=all_candidates`
          : stage !== 'all_candidates'
          ? `&stage=${stage}`
          : '';

      let sortKey = '';
      let sortType = '';
      let round = '';
      let sortSegment = '';
      let sortKeySegment = '';

      if (/roundToSort:/i.test(sortBy?.columnKey)) {
        const regex = /(.*)roundToSort:(.*)/i;
        const matches = sortBy?.columnKey?.match(regex);
        const before = matches?.[1]?.trim();
        const after = matches?.[2]?.trim();
        if (before && after) {
          sortType = `&sortType=${before === after ? 'round' : 'param'}`;
          round = `&round=${after}`;
          if (before !== after) sortKey = `&sort=${before}`;
        }
      } else if (sortBy?.columnKey) {
        sortKey = `&sort=${sortBy?.columnKey}`;
      }

      if (order) {
        sortSegment = `${round}${sortType}&order=${order}`;
        sortKeySegment = sortKey ? `${sortKey}` : '';
      }

      const rate = candidateRating?.minValue?.toString()
        ? `&startRank=${candidateRating.minValue}`
        : '';
      const maxRate = candidateRating?.maxValue?.toString()
        ? `&endRank=${candidateRating.maxValue}`
        : '';
      const degree =
        checkedIds?.length > 0 ? `&degreeStreamMapIds=${checkedIds}` : '';
      const collegeValue =
        college?.length > 0 ? `&collegeName=${college}` : '';
      let offer =
        stage === 'offer' && status !== 'ACTIVE' ? `&offerStatus=${status}` : '';
      const isAll = stage === 'all_candidates' ? `&isAllCandidate=true` : '';
      const bulkDownloadTrue = bulkDownload === true ? `&bulkDownload=true` : '';

      // Clean filterPayload if needed
      if (filterPayload) {
        const degreeIdList = filterPayload.degreeId || [];
        const departIdList = filterPayload.departId || [];
        const specialisationIdList = filterPayload.specialisationId || [];

        if (degreeIdList.length || departIdList.length || specialisationIdList.length) {
          const degreeMap = new Map();

          degreeIdList.forEach(({ value }) => {
            degreeMap.set(value, {
              degreeId: value,
              streamId: [],
              specialisationId: [],
            });
          });

          departIdList.forEach(({ degreeId, departId }) => {
            if (!degreeMap.has(degreeId)) {
              degreeMap.set(degreeId, {
                degreeId,
                streamId: [],
                specialisationId: [],
              });
            }
            degreeMap.get(degreeId).streamId.push(departId);
          });

          specialisationIdList.forEach(({ degreeId, specialisationId }) => {
            if (!degreeMap.has(degreeId)) {
              degreeMap.set(degreeId, {
                degreeId,
                streamId: [],
                specialisationId: [],
              });
            }
            degreeMap.get(degreeId).specialisationId.push(specialisationId);
          });
          
          filterPayload.degreeIds = Array.from(degreeMap.values());
          delete filterPayload.degreeId;
          delete filterPayload.departId;
          delete filterPayload.specialisationId;
        }
      }

      // Map status to offerStatus when in offer context
      const hasStatus = Array.isArray(filterPayload?.status)
        ? filterPayload.status.length > 0
        : typeof filterPayload?.status === 'string' && filterPayload.status.trim().length > 0

      const roundFilterHasOffer = Array.isArray(filterPayload?.roundFilter)
        ? filterPayload.roundFilter.some(v => String(v).toUpperCase().includes('OFFER'))
        : typeof filterPayload?.roundFilter === 'string'
        ? String(filterPayload.roundFilter).toUpperCase().includes('OFFER')
        : false

      const isOfferContext = String(stage).toLowerCase() === 'offer' || roundFilterHasOffer

      if (hasStatus && isOfferContext) {
        // Transform SELECTED -> NOT_RELEASED for offer mapping
        let statusForOffer = filterPayload.status
        if (Array.isArray(statusForOffer)) {
          statusForOffer = statusForOffer.map(s => (s === 'SELECTED' ? 'NOT_RELEASED' : s))
        } else if (typeof statusForOffer === 'string') {
          statusForOffer = statusForOffer === 'SELECTED' ? 'NOT_RELEASED' : statusForOffer
        }
        const offerStatusValue = Array.isArray(statusForOffer)
          ? statusForOffer.join(',')
          : statusForOffer
        offer = `&offerStatus=${offerStatusValue}`
        delete filterPayload.status
      }

      const finalURL = `/corporates/drive/${driveId}/role/${roleId}/candidate/list?pageLimit=10&pageNo=${currentPage}${search}${sortKeySegment}${sortSegment}${stageValue}${rate}${maxRate}${degree}${collegeValue}${offer}${candidateStatus}${activeStatus}${panel}${isAll}${bulkDownloadTrue}`;

      // The endpoint's body schema requires an object. Coerce anything that
      // isn't a plain object (null, undefined, or an array) to {} so a stale
      // array filter state can never produce "body must be object".
      const requestBody =
        filterPayload && !Array.isArray(filterPayload) ? filterPayload : {};
      const response = await corporateRequest.post(finalURL, requestBody);
      return response;
    } catch (error) {
      return error;
    }
  };

export const getDriveListData =
  ({
    currentPage,
    searchValue,
    corporateStatus,
    occurrence,
    driveRoles,
    driveMode,
    driveStatus,
    sortBy,
    driveStartDate,
    driveEndDate,
    pageLimit,
    roleId,
  }) =>
  async (dispatch, getState) => {
    try {
      let driveStatusArr = driveStatus?.filter(Boolean)
      let driveModeArr = driveMode?.filter(item => item)
      let driveRolesArr = driveRoles?.filter(Boolean)
      const state = getState()
      const coporateId = corporateSelector.getCorporateId(state)
      const search = searchValue ? `&search=${searchValue.trim()}` : ''
      const ongoingStatus = corporateStatus
        ? `&corporateStatus=${corporateStatus}`
        : ''
      const occurre = occurrence ? `&occurrence=${occurrence}` : ``
      const role = driveRolesArr?.length > 0 ? `&roles=${driveRolesArr}` : ``
      const mode = driveModeArr?.length > 0 ? `&driveMode=${driveModeArr}` : ``
      const status =
        driveStatusArr?.length > 0 ? `&corporateStatus=${driveStatusArr}` : ``
      const sortKey = sortBy?.columnKey ? `&sort=${sortBy?.columnKey}` : ''
      const order = sortBy?.order === 'ascend' ? 'asc' : 'desc'
      const sortOrder = sortBy?.order ? `&order=${order}` : ''
      const startDate = driveStartDate
        ? `&driveStartDate=${driveStartDate}`
        : ''
      const endDate = driveEndDate ? `&driveEndDate=${driveEndDate}` : ''
      const rolekey = roleId ? `&roles=${roleId}` : ''

      const response = await corporateRequest.get(
        `/corporates/${coporateId}/drive/list?pageLimit=${
          pageLimit || 10
        }&currentPage=${currentPage}${search}${ongoingStatus}${occurre}${role}${mode}${status}${sortKey}${sortOrder}${startDate}${endDate}${rolekey}`
      )
      return response
    } catch (error) {
      return error
    }
  }

export const getIndidualDriveMetrics = driveId => async dispatch => {
  try {
    const response = await corporateRequest.get(
      `/corporates/${driveId}/metrics`
    )
    dispatch(setDriveMetrics(response?.data?.data || {}))
    return response
  } catch (error) {
    return error
  }
}

export const getDriveRoleMetrics = driveId => async dispatch => {
  try {
    const response = await corporateRequest.get(
      `/corporates/${driveId}/roles/metrics`
    )
    dispatch(setDriveRolesMetrics(response?.data?.data || {}))
    return response
  } catch (error) {
    return error
  }
}

export const getRoleMetrics =
  (driveId, roleIdValue = '') =>
  async dispatch => {
    try {
      const response = await corporateRequest.get(
        `/corporates/drive/${driveId}/role/${roleIdValue}/metrics`
      )
      dispatch(setRoleMetrics(response?.data?.data || {}))
      return response
    } catch (error) {
      return error
    }
  }

export const getRoleList =
  (currentPage, forDriveFilter = false) =>
  async (dispatch, getState) => {
    const state = getState()
    const coporateId = corporateSelector.getCorporateId(state)
    try {
      const response = await corporateRequest.get(
        `corporates/${coporateId}/jobs/lists?pageLimit=10&pageNo=${
          currentPage || 0
        }&forDriveFilter=${forDriveFilter}`
      )
      return response
    } catch (error) {
      return error
    }
  }

export const requestToChange = (driveId, payload) => async () => {
  try {
    let response = await corporateRequest.patch(
      `/corporates/drive/${driveId}/requestToChangeDrive`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}

export const confirmDrive = (driveId, payload) => async () => {
  try {
    let response = await corporateRequest.patch(
      `/corporates/drive/${driveId}/updateDriveStatusToConfirm`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}

export const getInterviewerList = searchValue => async (dispatch, getState) => {
  try {
    const state = getState()
    const corporateId = authSelector.getCorporateId(state)
    const search = searchValue ? `&search=${searchValue.trim()}` : ''
    const response = await request.get(
      // Every ACTIVE user of the corporate can be an interviewer, whatever their role.
      `/user?currentPage=1&pageLimit=500&coporateId=${corporateId}&status=true${search}`
    )
    dispatch(setInterviewerList(response?.data?.data?.list || []))
    return response
  } catch (error) {
    return error
  }
}

export const getDriveInterviewerList = driveId => async dispatch => {
  try {
    const response = await corporateRequest.get(
      `/corporates/drive/${driveId}/interviewer/list`
    )
    dispatch(setDriveInterviewerList(response?.data?.data?.interviewere || []))
    return response
  } catch (error) {
    return error
  }
}

export const addInterviewer = (driveId, interviewId, payLoad) => async () => {
  try {
    const response = await corporateRequest.post(
      `/corporates/drive/${driveId}/addInterviewer/${interviewId}`,
      payLoad
    )
    return response
  } catch (error) {
    return error
  }
}

export const deleteInterviewer = (driveId, payload) => async () => {
  try {
    const response = await corporateRequest.delete(
      `/corporates/drive/${driveId}/deleteInterviewer`,
      { data: payload }
    )

    return response
  } catch (error) {
    return error
  }
}

const getOfferStatus = status => {
  if (status === 'SCHEDULED,SHORTLISTED,PENDING') {
    return 'NOT_RELEASED'
  } else if (status === 'HOLD') {
    return 'RELEASED'
  } else if (status === 'REJECTED') {
    return 'REJECTED'
  } else if (status === 'ACCEPTED') {
    return 'ACCEPTED'
  }
}

export const getDriveRoleCandidatesList =
  ({
    driveId,
    roleId,
    currentPage,
    searchValue,
    sortBy,
    status,
    stage,
    candidateRating,
    checkedIds,
    college,
    rolesMetrics,
  }) =>
  async () => {
    try {
      const search = searchValue ? `&searchBy=${searchValue.trim()}` : ''
      const sortKey = sortBy?.columnKey ? `&sort=${sortBy?.columnKey}` : ''
      const order = sortBy?.order === 'ascend' ? 'asc' : 'desc'
      const sortOrder = sortBy?.order ? `&order=${order}` : ''
      const candidateStatus = status
        ? `&status=${
            stage === 'offer'
              ? 'SELECTED'
              : stage === 'all_candidates'
              ? status === 'SCHEDULED,SHORTLISTED,PENDING'
                ? 'SCHEDULED,SHORTLISTED,SELECTED,PENDING'
                : status
              : status
          }`
        : ''

      const stageValue =
        stage !== 'all_candidates' && stage !== 'offer'
          ? `&stages=${stage}`
          : stage === 'offer'
          ? `&stages=${
              rolesMetrics[0]?.rounds[rolesMetrics[0]?.rounds?.length - 2]
                ?.roundName
            }`
          : ''

      let rate = candidateRating?.minValue?.toString()
        ? `&fromRating=${candidateRating?.minValue?.toString()}`
        : ''
      let maxRate = candidateRating?.maxValue?.toString()
        ? `&toRating=${candidateRating?.maxValue?.toString()}`
        : ''
      const degree =
        checkedIds?.length > 0 ? `&degreeStreamMapIds=${checkedIds}` : ''
      const collegeValue = college?.length > 0 ? `&collegeName=${college}` : ''
      const offerStatus = getOfferStatus(status)
      const offer = stage === 'offer' ? `&offerStatus=${offerStatus}` : ''
      const response = await studentRequest.get(
        `students/drive/${driveId}/role/${roleId}/candidate/list?pageLimit=10&pageNo=${currentPage}${search}${sortKey}${sortOrder}${candidateStatus}${stageValue}${rate}${maxRate}${degree}${collegeValue}${offer}`
      )

      return response
    } catch (error) {
      return error
    }
  }

export const getDegreeAndDepartMent = roleId => async dispatch => {
  try {
    const response = await corporateRequest.get(
      `/corporate/role/${roleId}/degree`
    )
    dispatch(setDegreeList(response?.data?.data || []))
    return response
  } catch (error) {
    return error
  }
}

export const getcollegeList = (driveId, roleId, search) => async dispatch => {
  try {
    let searchValue = search ? `?search=${search.tirm()}` : ''
    const response = await instituteRequest.get(
      `institutes/instituteCampus/drive/${driveId}/role/${roleId}/list${searchValue}`
    )
    dispatch(setCollegeList(response?.data?.data || []))
    return response
  } catch (error) {
    return error
  }
}

export const createInterview = (driveId, roleId, payload) => async () => {
  try {
    const response = await corporateRequest.post(
      `corporates/role/${roleId}/drive/${driveId}/setInterview`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}

export const downloadCandidate =
  (driveId, roleId, selectedFileType, selectedRound, selectedColumn) =>
  async () => {
    try {
      const round = selectedRound ? `&stage=${selectedRound}` : ''
      const key =
        selectedColumn?.length > 0 ? `&key=${selectedColumn.join(',')}` : ''

      const response = await studentRequest.get(
        `students/drive/${driveId}/list?roleId=${roleId}&type=${selectedFileType}${round}${key}`
      )
      return response
    } catch (error) {
      return error
    }
  }

export const addTimeBreak = (driveId, payload) => async () => {
  try {
    const response = await corporateRequest.put(
      `/corporates/drive/${driveId}/addBreak`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}

export const getSingleCandidateInterviewDetails =
  (roleId, driveId, studentId) => async dispatch => {
    try {
      const response = await corporateRequest.get(
        `/corporates/role/${roleId}/drive/${driveId}/student/${studentId}/interview`
      )
      dispatch(setCandidateInterviewDetails(response?.data?.data))
      return response
    } catch (error) {
      return error
    }
  }

export const getGroupDiscussionList =
  (roleId, driveId, interviewRound, status, currentPage) =>
  async (dispatch, getState) => {
    return new Promise(resolve => {})
  }

export const getGroupCandidateList =
  (roleId, driveId, interviewId, groupId, status, stage) => async dispatch => {
    try {
      const candidateStatus = status ? `?status=${status}` : ''
      const stageValue = stage ? `&stage=${stage}` : ''
      const response = await corporateRequest.get(
        `/corporates/role/${roleId}/drive/${driveId}/interview/${interviewId}/group/${groupId}/groupCandidateList${candidateStatus}${stageValue}`
      )
      dispatch(setGroupCandidateList(response?.data?.data))
      return response
    } catch (error) {
      return error
    }
  }

export const updateInterviewStatus = (driveId, roleId, payload) => async () => {
  try {
    const response = await corporateRequest.post(
      `corporates/role/${roleId}/drive/${driveId}/updateStatus`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}

export const getCities =
  ({ searchValue }) =>
  async dispatch => {
    let SearchKey = searchValue ? `&search=${searchValue.trim()}` : ''
    try {
      const result = await request.get(
        `cities?pageLimit=50&currentPage=1${SearchKey}`
      )
      dispatch(setCityList(result?.data?.data))
      return result
    } catch (error) {
      dispatch(setCityList([]))
    }
  }

export const releaseOfferAPI = (driveId, roleId, payload) => async () => {
  try {
    const response = await corporateRequest.post(
      `corporates/role/${roleId}/drive/${driveId}/realeaseOffer`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}

export const downloadCandidateList =
  (driveId, roleId, selectedRound, payload) => async () => {
    try {
      const response = await studentRequest.post(
        `students/role/${roleId}/drive/${driveId}/interview/candidateListFileForUploadResult?type=xlsx`,
        payload
      )
      return response
    } catch (error) {
      return error
    }
  }

export const uploadResultAPI = (driveId, roleId, payload) => async () => {
  try {
    const response = await corporateRequest.post(
      `corporates/role/${roleId}/drive/${driveId}/bulkResultUpload`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}

export const getInstituteData = instituteCampusId => async () => {
  try {
    const response = await instituteRequest.get(
      `/institutes/instituteCampus/${instituteCampusId}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const recreateCall = (driveId, payload, status) => async () => {
  try {
    const response = await corporateRequest.post(
      `/corporates/virtualDrive/${driveId}/recreate`,
      payload
    )
    if (response?.status == 200) {
      status('Success')
      SuccessMessage('Updated Successfully')
    }
    return response
  } catch (error) {
    status('FAILURE')
    ErrorMessage('Recreation Failed!')
    return error
  }
}

export const fileUpload =
  (roleId, driveId, payload, stage, round) => async () => {
    try {
      const interviewRound =
        stage === 'EXTERNAL_ASSESMENT' ? `?interviewRound=${round}` : ''
      const formData = new FormData()
      formData.append('files', payload.originFileObj)
      const response = await corporateRequest.post(
        `/corporates/role/${roleId}/drive/${driveId}/upload/externalAssessmentFile${interviewRound}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      return response
    } catch (error) {
      return error
    }
  }

export const getCandidateDocumentsMetrices =
  ({ roleId, driveId, corporateId }) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const corporateId = authSelector.getCorporateId(state)
      const response = await studentRequest.get(
        `/students/corporate/${corporateId}/drive/${driveId}/role/${roleId}/reqDoc/metrices`
      )
      dispatch(setCandidateDocumentsMetrices(response?.data?.data))

      return response
    } catch (error) {
      return error
    }
  }
export const uploadResultStatusUpdate =
  (driveId, roleId, payload) => async () => {
    try {
      const response = await corporateRequest.post(
        `corporates/drive/${driveId}/role/${roleId}/candidate/bulk/status`,
        payload
      )
      return response
    } catch (error) {
      return error
    }
  }

export const downloadSampleFile = (driveId, roleId, payload) => async () => {
  const stage =  payload.stage === null ? `?stage=all_candidates` : `?stage=${payload.stage}`
  try {
    const response = await studentRequest.get(
      `students/drive/${driveId}/role/${roleId}/candidate/list/export${stage}`
    )
    return response
  } catch (error) {
    return error
  }
}
export const getRounds = (roleId, stage, search) => async () => {
  const query = stage === null ? `?stage=all_candidates` : `?stage=${stage}`
  const searchValue = search ? `&search=${search.trim()}` : ''
  try {
    const response = await corporateRequest.get(
      `/corporate/eligibilityCriteria/role/${roleId}/rounds/filter${query}${searchValue}`
    )

    return response?.data?.data
  } catch (error) {
    return error
  }
}
export const getStatus = (roleId, stage, search) => async (dispatch) => {
  const query = stage === null ? `?stage=all_candidates` : `?stage=${stage}`
  const searchValue = search ? `&search=${search.trim()}` : ''
  try {
    const response = await corporateRequest.get(
      `/corporate/eligibilityCriteria/role/${roleId}/status/filter${query}${searchValue}`
    )
    // await dispatch(setStatusList(response?.data?.data))

    return response?.data?.data
  } catch (error) {
    return error
  }
}

export const getYear = (roleId, stage, search) => async () => {
  const query = stage === null ? `?stage=all_candidates` : `?stage=${stage}`
  const searchValue = search ? `&search=${search.trim()}` : ''
  try {
    const response = await corporateRequest.get(
      `/corporate/eligibilityCriteria/role/${roleId}/year/filter${query}${searchValue}`
    )

    return response?.data?.data
  } catch (error) {
    return error
  }
}

export const getCollegeListForFilter = (roleId, stage, search) => async () => {
  const query = stage === null ? `?stage=all_candidates` : `?stage=${stage}`

  let searchValue = ''
  if (search && typeof search === 'object') {
    if (search?.stateSearch) {
      searchValue += `&stateSearch=${encodeURIComponent(
        search.stateSearch.trim()
      )}`
    }
    if (search?.citySearch) {
      searchValue += `&citySearch=${encodeURIComponent(
        search.citySearch.trim()
      )}`
    }
  }
  if (search?.collegeSearch) {
    searchValue += `&collegeSearch=${encodeURIComponent(
      search.collegeSearch.trim()
    )}`
  }
  try {
    const response = await corporateRequest.get(
      `/corporate/eligibilityCriteria/role/${roleId}/college/filter${query}${searchValue}`
    )
    return response?.data?.data
  } catch (error) {
    return error
  }
}
export const getSkillForFilter = (roleId, stage, search) => async () => {
  const query = stage === null ? `?stage=all_candidates` : `?stage=${stage}`
  const searchValue = search ? `&search=${search?.trim()}` : ''
  try {
    const response = await corporateRequest.get(
      `/corporate/eligibilityCriteria/role/${roleId}/jobRoleSkill/filter${query}${searchValue}`
    )
    return response?.data?.data
  } catch (error) {
    return error
  }
}

export const getQuestionForFilter = (roleId, stage, search) => async () => {
  const query = stage === null ? `?stage=all_candidates` : `?stage=${stage}`
  const searchValue = search ? `&search=${search?.trim()}` : ''
  try {
    const response = await corporateRequest.get(
      `/corporate/eligibilityCriteria/role/${roleId}/questions/filter${query}${searchValue}`
    )
    return response?.data?.data
  } catch (error) {
    return error
  }
}

export const getCustomQuestionFilterOptions = (roleId) => async () => {
  try {
    const response = await corporateRequest.get(
      `/corporates/jobs/${roleId}/custom-questions/filter-options`
    )
    return response?.data?.data?.questions || []
  } catch (error) {
    return []
  }
}

export const getWorkExperienceForFilter =
  (roleId, stage, search) => async () => {
    let searchValue = ''
    if (search && typeof search === 'object') {
      if (search.functionSearch) {
        searchValue += `&functionSearch=${encodeURIComponent(
          search.functionSearch.trim()
        )}`
      }
      if (search.roleSearch) {
        searchValue += `&roleSearch=${encodeURIComponent(
          search.roleSearch.trim()
        )}`
      }
    }
    const query = stage === null ? `?stage=all_candidates` : `?stage=${stage}`
    try {
      const response = await corporateRequest.get(
        `/corporate/eligibilityCriteria/role/${roleId}/workexperience/filter${query}${searchValue}`
      )
      return response?.data?.data
    } catch (error) {
      return error
    }
  }

export const getLocationForFilter = (roleId, stage, search) => async () => {
  const query = stage === null ? `?stage=all_candidates` : `?stage=${stage}`
  let searchValue = ''
  if (search && typeof search === 'object') {
    if (search.psSearch) {
      searchValue += `&psSearch=${encodeURIComponent(search.psSearch.trim())}`
    }
    if (search.pcSearch) {
      searchValue += `&pcSearch=${encodeURIComponent(search.pcSearch.trim())}`
    }
    if (search.csSearch) {
      searchValue += `&csSearch=${encodeURIComponent(search.csSearch.trim())}`
    }
    if (search.ccSearch) {
      searchValue += `&ccSearch=${encodeURIComponent(search.ccSearch.trim())}`
    }
  } else if (typeof search === 'string' && search) {
    searchValue += `&search=${encodeURIComponent(search.trim())}`
  }
  try {
    const response = await corporateRequest.post(
      `/corporate/eligibilityCriteria/role/${roleId}/location/filter${query}${searchValue}`
    )
    return response?.data?.data
  } catch (error) {
    return error
  }
}

export const getDegreeForFilter = (roleId, stage, payload) => async () => {
  try {
    const query = stage === null ? `?stage=all_candidates` : `?stage=${stage}`
    const response = await corporateRequest.post(
      `/corporate/eligibilityCriteria/role/${roleId}/degree/filter${query}`,
      payload
    )
    return response?.data?.data
  } catch (error) {
    return error
  }
}

export const resumeBulkDownload = payload => async () => {
  try {
    const options = {}

    if (payload?.studentIds?.length <= 5) {
      options.responseType = 'blob'
    }

    const response = await studentRequest.post(
      `/students/resume/bulkdownload`,
      payload,
      options
    )

    return response
  } catch (error) {
    console.error('Download error:', error)
    return { error }
  }
}

// `corporate: true` is stamped here rather than at each call site because every
// caller of this action is the corporate portal. It makes student-node serve the
// candidate's own uploaded CV for the role and never a generated system resume,
// answering 422 when nothing was uploaded. Other portals hit the same endpoint
// without the flag and keep the system-resume fallback.
export const resumeBulkDownloadJobRoles = payload => async () => {
  try {
    const options = {}

    if (payload?.studentIds?.length <= 5) {
      options.responseType = 'blob'
    }

    const response = await studentRequest.post(
      `/students/resume/bulkdownload/jobRoles`,
      { ...payload, corporate: true },
      options
    )

    return response
  } catch (error) {
    console.error('Download error:', error)
    return { error, errorMessage: await readDownloadErrorMessage(error) }
  }
}

export const updateNewRound = (payload, id) => async (dispatch, getState) => {
  try {
    dispatch(updateRoundData(''))
    const result = await corporateRequest.put(
      `corporates/role/${id}/interviewRounds`,
      payload
    )
    dispatch(updateRoundData(result?.data))
    SuccessMessage('New round added successfully')
    return result
  } catch (error) {}
}

export const addNewRound = id => async (dispatch, getState) => {
  try {
    const result = await corporateRequest.get(
      `corporates/role/${id}/interviewRounds`
    )
    dispatch(setRoundData(result?.data?.data))
    return result
  } catch (error) {
    console.log(error)
  }
}

export const downloadTemplate = (id, payload) => async (dispatch, getState) => {
  try {
    const result = await corporateRequest.post(
      `/corporates/role/${id}/candidate/shortlist/excel`,
      payload,
      { responseType: 'blob' } // Ensure binary download
    )

    return result
  } catch (error) {
    console.log(error)
  }
}
export const uploadShorlistResult =
  (id, payload) => async (dispatch, getState) => {
    try {
      const state = getState()
      const corporateId = corporateSelector.getCorporateId(state)
      const result = await corporateRequest.post(
        `/corporates/${corporateId}/role/${id}/candidate/shortlist/statusUpdate`,
        payload
      )
      return result
    } catch (error) {
      // Re-throw the error so it can be handled in the component
      return error
    }
  }
  export const getExportFiledData = () => async (dispatch, getState) => {
    try {
      const response = await studentRequest.get(
        `/students/institutes/heading/export`
      )
      return response?.data?.data
    } catch (error) {
      ErrorMessage('Error fetching roles, Try again .')
    }
    
}

export const atsExportCandidate =
    (roleId, corporateId, key, payLoad) => async (dispatch, getState) => {
    try {
      const config = key !== 'googlesheet' ? { responseType: 'blob' } : {}
      const response = await studentRequest.post(
        `/students/role/${roleId}/corporate/${corporateId}/candidates/${key}/export`,
        payLoad,
        config
      )
      return response?.data
    } catch (err) {
      ErrorMessage('Error fetching roles, Try again.')
      throw err // Ensure error is thrown to be caught in the calling function
    }
  }

  export const getConflictCandidates = (roleId, payload) => async () => {
    try {

      let query = {
        pageLimit: 10,
      };
      
      if (payload.pageNo !== undefined && payload.pageNo !== null) {
        query.pageNo = payload.pageNo;
      }
      
      if (payload.roundId !== undefined && payload.roundId !== null) {
        query.roundId = payload.roundId;
      }
      
      if (payload.roundId === undefined || payload.roundId === null) {
        query.stage = payload?.stage || 'all_candidates';
      } else if (payload?.stage) {
        query.stage = payload?.stage;
      }
      if (payload.search ) {
        query.search = payload.search;
      }
      const response = await corporateRequest.get(
        `/corporates/job/${roleId}/conflictCandidates/list`,
        { params: query }
      );
  
      return response.data.data;
    } catch (error) {
      return error;
    }
  };
  
  export const updateResolveConflictCandidates = (roleId, conflictId, payload) => async () => {
    try {
      const response = await corporateRequest.post(
        `/corporates/role/${roleId}/resolveConflict/${conflictId}/shortlist`,
        payload
      );
      return response;
    } catch (error) {
      return error;
    }
    }

export const getRoundAssessmentMapping = ({ driveId, roleId, round }) => async () => {
  try {
    const response = await corporateRequest.get(
      `/corporates/drive/${driveId}/role/${roleId}/round-mapping`,
      { params: { round } }
    )
    const mappings = response?.data?.data?.mappings
    return { ok: true, mappings: Array.isArray(mappings) ? mappings : [] }
  } catch (error) {
    return { ok: false, mappings: [] }
  }
}

export const upsertRoundAssessmentMapping = ({
  driveId,
  roleId,
  round,
  assessmentCorporateMapIds,
}) => async () => {
  try {
    const response = await corporateRequest.put(
      `/corporates/drive/${driveId}/role/${roleId}/round-mapping`,
      { round, assessment_corporate_map_ids: assessmentCorporateMapIds }
    )
    SuccessMessage('Assessments updated. Refreshing scores.')
    const mappings = response?.data?.data?.mappings
    return { ok: true, mappings: Array.isArray(mappings) ? mappings : [] }
  } catch (error) {
    const msg = error?.response?.data?.message || 'Failed to update assessments'
    ErrorMessage(msg)
    return { ok: false }
  }
}

export const deleteRoundAssessmentMapping = ({
  driveId,
  roleId,
  round,
  assessmentCorporateMapId,
}) => async () => {
  try {
    await corporateRequest.delete(
      `/corporates/drive/${driveId}/role/${roleId}/round-mapping`,
      { params: { round, assessment_corporate_map_id: assessmentCorporateMapId } }
    )
    SuccessMessage('Assessment unmapped from this round.')
    return { ok: true }
  } catch (error) {
    ErrorMessage('Failed to unmap assessment')
    return { ok: false }
  }
}

export const listCorporateAssessments = ({ corporateId }) => async () => {
  try {
    const response = await corporateRequest.get(
      `/corporates/${corporateId}/assessments`
    )
    return { ok: true, items: response?.data?.data?.items ?? [] }
  } catch (error) {
    return { ok: false, items: [] }
  }
}

  